<template>
    <div class="top__swiper" v-if="banners_length === 1">
        <!-- １枚バナー START -->
        <a :href="banners[0].link" :target="banners[0].is_blank ? '_blank' : ''">
            <img class="readimg-one" :src="banners[0].image" :alt="banners[0].alt">
        </a>
    </div>

    <div class="top__swiper" v-else>
        <!-- Swiper -->
        <swiper 
            ref="mySwiper"
            :effect="effect"
            :loop="loop"
            :loopAdditionalSlides="loopAdditionalSlides"
            :spaceBetween="spaceBetween"
            :slidesPerView="slidesPerView"
            :breakpoints="breakpoints"
        >
            <swiper-slide v-for="(banner, index) in banners" :key="index">
                <a :href="banner.link" :target="banner.is_blank ? '_blank' : ''">
                    <img :src="banner.image" :alt="banner.alt">
                </a>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
    export default {
        props: {
            banners: Array
        },

        data() {
            return {
                banners_length: 0,
                effect: 'slide',
                loop: Boolean,
                spaceBetween: 16,
                slidesPerView: 3,
                loopAdditionalSlides: 1,
                breakpoints: {
                    750: {
                        slidesPerView: 3,
                        spaceBetween: 40,
                    }
                }
            }
        },

        created() {
            this.banners_length = this.banners.length;
            if(window.matchMedia('(max-width: 767px)').matches) {
                this.loop = true
            } else {
                this.loop = false
            }
        },

        computed: {
            swiper() {
                return this.$refs.mySwiper.swiper;
            }
        },
    }
</script>
